import CRUDTableEntity from "./CRUDTableEntity";
export default class ProjSettings extends CRUDTableEntity {
    constructor(guid = undefined) {
        super("PROJ", guid);
        this.projectGuid = guid;
        this.dateFormat = "ddd DD/MM/YYYY";
        this.sectorStart = "Number10";
        this.sectorEnd = "unused";
    }
}
